var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatbotPopupButtonGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_48288",
    "data-name": "Group 48288",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.104,
    height: 34.147,
    viewBox: "0 0 37.104 34.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54321",
    "data-name": "Path 54321",
    d: "M35.479,34A14.486,14.486,0,0,0,21.036,20.4H16.068A14.486,14.486,0,0,0,1.626,34,2.69,2.69,0,0,0,0,36.468v5.6a2.69,2.69,0,0,0,2.686,2.686H4.861V33.781H3.821A12.312,12.312,0,0,1,16.068,22.574h4.968A12.312,12.312,0,0,1,33.283,33.781H32.244V44.758h2.174A2.69,2.69,0,0,0,37.1,42.072v-5.6A2.69,2.69,0,0,0,35.479,34Z",
    transform: "translate(0 -20.4)",
    fill: "#387f75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54322",
    "data-name": "Path 54322",
    d: "M117.129,158.1H100.046a2.979,2.979,0,0,0-2.976,2.976v13.543a2.979,2.979,0,0,0,2.976,2.976h3.726l3.623,4.289a1.087,1.087,0,0,0,1.661,0l3.623-4.289h4.45a2.979,2.979,0,0,0,2.976-2.976V161.076A2.979,2.979,0,0,0,117.129,158.1Zm-4.569,5.444a1.087,1.087,0,1,1-1.087,1.087A1.087,1.087,0,0,1,112.56,163.544Zm-8.406,0a1.087,1.087,0,1,1-1.087,1.087A1.087,1.087,0,0,1,104.155,163.544Zm9.851,6.595a7.714,7.714,0,0,1-10.837,0,1.087,1.087,0,1,1,1.443-1.626,5.544,5.544,0,0,0,7.952,0,1.087,1.087,0,0,1,1.442,1.626Z",
    transform: "translate(-90.035 -148.121)",
    fill: "#387f75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotPopupButtonGreen);
export default __webpack_public_path__ + "static/media/chatbot-popup-button-green.f592393bc0a61d043e7389e3aa7a2504.svg";
export { ForwardRef as ReactComponent };